import { useNavigate } from 'react-router-dom';

const addons = [
  {
    emoji: '🚀',
    icon: 'ri-user-star-line',
    title: 'ИИ-Аватар',
    subtitle: 'Видео-контент без съёмок',
    what: 'Создаём цифрового двойника эксперта или персонажа бренда.',
    how: 'Вы присылаете текст — мы получаем видео, где ваш аватар говорит вашим голосом с идеальной мимикой и жестами.',
    benefit: 'Вам больше не нужно тратить дни в студии. ИИ записывает видео за вас 24/7.',
    cta: 'Узнать подробнее об ИИ-Аватаре',
    color: 'from-[#1A2B4C] to-[#253D6B]',
    link: '/AI-avatar',
  },
  {
    emoji: '✍️',
    icon: 'ri-quill-pen-line',
    title: 'Нейро-Копирайтинг',
    subtitle: 'Смыслы на месяц',
    what: 'Детальная проработка 20–30 текстов для постов и рассылок.',
    how: 'Используем ИИ-агентов для анализа «болей» ЦА и пишем тексты, закрывающие возражения по методике JTBD.',
    benefit: 'Тексты экспертного уровня, которые читают до конца.',
    cta: 'Заказать тексты',
    color: 'from-[#2C4A2E] to-[#3A6040]',
    link: null,
  },
  {
    emoji: '🎬',
    icon: 'ri-film-line',
    title: 'Reels/Shorts «Под ключ»',
    subtitle: 'Алгоритмический охват',
    what: 'Разработка 10–15 сценариев с триггерными заголовками и монтаж видео.',
    how: 'Используем ваши исходники или стоковые видео через ИИ — с субтитрами и трендовой музыкой.',
    benefit: 'Выход в ТОПы и бесплатный охват за счёт алгоритмов.',
    cta: 'Заказать Reels/Shorts',
    color: 'from-[#4A2A1A] to-[#6B3D24]',
    link: null,
  },
  {
    emoji: '🔍',
    icon: 'ri-search-eye-line',
    title: 'AI-Аудит ваших соцсетей',
    subtitle: 'Анализ и точки роста',
    what: 'Глубокий анализ ваших аккаунтов нейросетями.',
    how: 'Выявление причин низкой конверсии и поиск «точек роста» на основе данных, а не догадок.',
    benefit: 'Конкретный список правок, которые увеличат продажи уже завтра.',
    cta: 'Заказать аудит',
    color: 'from-[#1A2B4C] to-[#2A3F6B]',
    link: null,
  },
];

export default function SMMAddons() {
  const navigate = useNavigate();

  const scrollToForm = () => {
    const el = document.getElementById('smm-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-cpu-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Add-ons
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Точечные нейро-услуги
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-base text-gray-500 font-['Montserrat'] max-w-2xl mx-auto leading-relaxed">
            Иногда бизнесу не нужен полный пакет, но требуются высокотехнологичные решения.
            Вы можете заказать их отдельно.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
          {addons.map((addon) => (
            <div
              key={addon.title}
              className={`bg-gradient-to-br ${addon.color} rounded-2xl p-6 sm:p-8 flex flex-col`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white/10 border border-white/20 flex-shrink-0">
                  <i className={`${addon.icon} text-xl text-[#C5A880]`}></i>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white font-['Playfair_Display'] leading-snug">
                    {addon.title}
                  </h3>
                  <p className="text-[#C5A880] text-xs font-semibold font-['Montserrat']">
                    {addon.subtitle}
                  </p>
                </div>
              </div>

              <div className="space-y-2.5 flex-1">
                <div className="flex items-start gap-2">
                  <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] whitespace-nowrap mt-0.5">Что делаем:</span>
                  <p className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify">{addon.what}</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] whitespace-nowrap mt-0.5">Как работает:</span>
                  <p className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify">{addon.how}</p>
                </div>
                <div className="border-t border-white/10 pt-2.5 flex items-start gap-2">
                  <i className="ri-flashlight-line text-[#C5A880] text-sm flex-shrink-0 mt-0.5"></i>
                  <p className="text-white/60 text-xs leading-relaxed font-['Montserrat'] italic">{addon.benefit}</p>
                </div>
              </div>

              {addon.link ? (
                <button
                  type="button"
                  onClick={() => navigate(addon.link!)}
                  className="mt-5 w-full bg-white hover:bg-white/90 text-[#1A2B4C] text-sm font-semibold font-['Montserrat'] py-3 px-5 rounded-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  {addon.cta}
                  <i className="ri-arrow-right-line"></i>
                </button>
              ) : (
                <button
                  type="button"
                  onClick={scrollToForm}
                  className="mt-5 w-full bg-[#C5A880] hover:bg-[#B39770] text-white text-sm font-semibold font-['Montserrat'] py-3 px-5 rounded-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  {addon.cta}
                  <i className="ri-arrow-right-line"></i>
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
